import EmptyList from '@anm/components/EmptyList';
import TitleBlock from '@anm/components/TitleBlock';
import { flexColumn, flexRow, media } from '@anm/styles/helpers';
import styled from 'styled-components';

export const Error = styled(EmptyList)``;

const wrapperOnMobiles = media.tablet`
  padding: 0 19px;
  margin: 0;
`;

export const Wrapper = styled.div`
  ${flexColumn};
  margin: 0 -27px;

  ${wrapperOnMobiles};
`;

export const Title = styled(TitleBlock)`
  h1,
  h2,
  h3,
  h4,
  h5 {
    font-size: 18px;
    line-height: 24px;
  }
`;

export const TitleContainer = styled.div`
  padding: 10px 0 20px;
`;

export const ButtonsWrapper = styled.div`
  ${flexRow};
  gap: 10px;
  margin-bottom: 20px;

  button {
    padding: 0 20px;
  }
`;
